// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/image-search/data-section/data-section-tabs/data-section-tabs.component.scss"],"names":[],"mappings":"AACA;EACI,aAAA;AAAJ","sourcesContent":["// TODO this is a dup, point this component to higher scss\n.hide {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
